import { Injectable } from "@angular/core";
import { BaseModel } from "./base-model";
import { HttpService } from "../../services/http.service";
import { LanguageAsset } from "../vo/language-asset";
import { LanguageJsonModelService } from "./language-json-model.service";

@Injectable()
export class CourseMenuModelService extends BaseModel {
	private menuXmlData: XMLDocument;
	private playerLanguages: Array<any> = [];
	private arrLanguageAssets: LanguageAsset[] = [];
	private arrTileImages: Array<any> = [];
	private _strComplianceTypeID: string;
	private _strComplianceTypeName: string;

	constructor(
		private httpService: HttpService,
		private languageJsonModel: LanguageJsonModelService
	) {
		super();
	}

	public initialize(data: any) {
		this.playerLanguages = this.languageJsonModel.allLanguages;
		this.loadMenuXML(data);
	}

	private loadMenuXML(url) {
		this.httpService.getXmlData(url).then((res: any) => {
			//this.menuXmlData = res._body;
			this.menuXmlData = res;
			this.parseMenuXml();
			this._notifier.next("data");
		}).catch(err => {
			console.error('HTTP request failed', err)
		});
	}

	private parseMenuXml(): void {
		this.parseLanguageAssets();
		this.parseTiles();
		this.parseComplianceTypeIDAndName();
	}

	private parseLanguageAssets(): void {
		let langAsset: LanguageAsset;
		const xmlLangAsset = this.menuXmlData.getElementsByTagName("langAssets");
		for (let i = 0; i < xmlLangAsset.length; i++) {
			langAsset = new LanguageAsset();
			langAsset.lang = xmlLangAsset[i].getAttribute("language");
			let localName = xmlLangAsset[i]
				.getAttribute("localName")
				.split("/")
				.pop()
				.replace(".swf", "");
			langAsset = Object.assign({}, langAsset, this.getLang(localName));
			this.arrLanguageAssets.push(langAsset);
		}
	}

	private parseTiles(): void {
		const xmlTile = this.menuXmlData.getElementsByTagName("tile");
		for (let i = 0; i < xmlTile.length; i++) {
			this.arrTileImages.push({
				id: xmlTile[i].getAttribute("id"),
				image: xmlTile[i].getElementsByTagName(`tileImage`).item(0).textContent,
			});
		}
	}

	private parseComplianceTypeIDAndName(){
		let cId = this.menuXmlData.getElementsByTagName("complianceTypeID")[0];
		let cName = this.menuXmlData.getElementsByTagName("complianceTypeName")[0];
		this._strComplianceTypeID = cId?cId.textContent.trim():"";
		this._strComplianceTypeName = cName?cName.textContent.trim():"";	
	}

	private getLang(langCode: string): Object {
		return this.playerLanguages.find((x) => x.langAsset === langCode);
	}

	public get languageAssets(): LanguageAsset[] {
		return this.arrLanguageAssets;
	}

	public get menuXml(): any {
		return this.menuXmlData;
	}

	public get tileImages(): any {
		return this.arrTileImages;
	}

	public get strComplianceTypeID(){
		return this._strComplianceTypeID;
	}

	public get strComplianceTypeName(){
		return this._strComplianceTypeName;
	}
}
